module.exports = __webpack_public_path__ + "img/Le-Cordon-Bleu-logo.8a61621d.png";